var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"play-mode",attrs:{"type":"button"},on:{"click":_vm.toggle}},[_vm._v("落子方式: "+_vm._s(_vm.mode === 'quick' ? '快速' : '按钮'))])}
var staticRenderFns = []

export { render, staticRenderFns }